<template>
    <div class="container o-form-page">
        <o-working-overlay :working="working"></o-working-overlay>

        <o-section :level="0" :title="title" @click="enableDebug($event)">
            <item-form
                :form-state="formState"
                :item="item"
                :server-errors="serverErrors"
                :advanced-usage="advancedUsage"
            ></item-form>
        </o-section>

        <o-action-buttons
            :create="false"
            :form-state="formState"
            :item="item"
            hide-delete
            @save="doSave"
            @saveAndClose="doSaveAndClose"
            @saveAndNew="doSaveAndClose"
        ></o-action-buttons>
    </div>
</template>

<script>
import {
    CreateFormPageMixin,
    CreateGroupPermissionMixin,
    UnsavedMixin,
} from "../../../mixins";
import ItemForm from "../components/Account.vue";
import OActionButtons from "../../../components/forms/OActionButtons.vue";
import OSection from "../../../components/layout/OSection.vue";
import OWorkingOverlay from "../../../components/OWorkingOverlay.vue";
import { mapGetters } from "vuex";

export default {
    mixins: [
        UnsavedMixin,
        CreateFormPageMixin("UserAccount", "user"),
        CreateGroupPermissionMixin("User"),
    ],
    components: {
        OSection,
        OWorkingOverlay,
        OActionButtons,
        ItemForm,
    },
    props: {
        advancedUsage: {
            type: Boolean,
            default: false,
        },
    },
    methods: {},
    computed: {
        ...mapGetters("AuthModule", ["currentUser"]),
        title() {
            return "Edit Account";
        },
    },
};
</script>
